/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GTMBannerViewPayload } from '@/data/types/GTM';

export const getGTMBannerViewEventData = async (payload: GTMBannerViewPayload) => ({
	banner_name: payload.banner_name,
	banner_url: payload.banner_url,
	banner_position: payload.banner_position,
});
